import React, { useContext, useEffect, useState } from 'react'

import { getSectionByCodeOrName } from '../../../assets/ts/data/common-metadata'
import { defaultToEmptyString, twoDigits } from '../../../assets/ts/formatting/formatting'
import useInquiryCount from '../../../hooks/inquiry/use-inquiry-count'
import { MetadataContext } from '../../../store/metadata-context-provider'
import { RoleContext } from '../../../store/role-context-provider'
import { UserContext } from '../../../store/user-context-provider'
import Accordions from '../../accordions/accordions'
import DetailKPIs from '../detail-kpis/detail-kpis'
import ResponseKPIs from '../response-kpis/response-kpis'

const AccordionKPIs = ({ filter, setKpiName, updateKpiFilter }: any) => {
  const [currentSection, setCurrentSection] = useState(null)
  const {
    isAFRCOwner,
    isANGOwner,
    isCPOwner,
    isLeadership,
    isMAJCOMOwner,
    isMPFOwner,
    isRegAFOwner,
    isSectionChief,
    isSectionOwner,
    isSupervisor,
    isTechnician,
    mpfSection,
  } = useContext(RoleContext)
  const isOwnerOrLeadership =
    isAFRCOwner ||
    isANGOwner ||
    isRegAFOwner ||
    isMPFOwner ||
    isMAJCOMOwner ||
    isCPOwner ||
    isLeadership

  const { me } = useContext(UserContext)

  const { sections } = useContext(MetadataContext)

  const updateFilters = (filtersToUpdate, defaultFilters) => {
    const result = { ...filtersToUpdate }
    for (const key in defaultFilters) {
      if (Object.prototype.hasOwnProperty.call(filtersToUpdate, key)) {
        result[key] = defaultFilters[key]
      }
    }
    return result
  }

  const responseRequestedVisibility = () => {
    //Established visibility
    const canSeeEverything = [
      isCPOwner,
      isLeadership,
      isMPFOwner,
      isSectionChief,
      isMAJCOMOwner,
      isSectionOwner,
      isSupervisor,
      isTechnician,
    ].some(Boolean)

    if (canSeeEverything) {
      return true
    } else {
      return false
    }
  }
  const responsePendingVisibility = () => {
    //Established visibility
    const canSeeEverything = [
      isCPOwner,
      isLeadership,
      isMPFOwner,
      isMAJCOMOwner,
      isSectionChief,
      isSectionOwner,
      isSupervisor,
      isTechnician,
    ].some(Boolean)

    if (canSeeEverything) {
      return true
    } else {
      return false
    }
  }

  const { inquiryCount: careerDevelopmentCount } = useInquiryCount({
    ...updateFilters(filter, {
      activeFilter: filter?.tabTable === 'ACTIVE' && filter?.activeFilter,
      assignedToMe: null,
      assignedToOther: null,
      currentSection: null,
      customerActionRequiredFilter: null,
      elevatedToMPF: null,
      isCPOwnerOrLeadership: null,
      isResponsePending: null,
      isResponseRequired: null,
      needToWorkFilter: null,
      pendingActionOutsideFilter: null,
      returnedFromMPF: null,
      sectionCodeFilter: 1,
      sectionCodeKPIFilter: 1,
      statusCodeFilter: '',
      unassignedFilter: filter?.tabTable === 'UNASSIGNED' && filter?.unassignedFilter,
    }),
  })
  const { inquiryCount: customerSupportCount } = useInquiryCount({
    ...updateFilters(filter, {
      activeFilter: filter?.tabTable === 'ACTIVE' && filter?.activeFilter,
      assignedToMe: undefined,
      assignedToOther: undefined,
      currentSection: undefined,
      customerActionRequiredFilter: null,
      elevatedToMPF: null,
      isCPOwnerOrLeadership: null,
      isResponsePending: undefined,
      isResponseRequired: undefined,
      pendingActionOutsideFilter: null,
      returnedFromMPF: null,
      sectionCodeFilter: 2,
      sectionCodeKPIFilter: 2,
      statusCodeFilter: undefined,
      unassignedFilter: filter?.tabTable === 'UNASSIGNED' && filter?.unassignedFilter,
    }),
  })
  const { inquiryCount: forceManagementCount } = useInquiryCount({
    ...updateFilters(filter, {
      activeFilter: filter?.tabTable === 'ACTIVE' && filter?.activeFilter,
      assignedToMe: undefined,
      assignedToOther: undefined,
      customerActionRequiredFilter: null,
      elevatedToMPF: null,
      isCPOwnerOrLeadership: null,
      isResponsePending: undefined,
      isResponseRequired: undefined,
      pendingActionOutsideFilter: null,
      returnedFromMPF: null,
      sectionCodeFilter: 3,
      sectionCodeKPIFilter: 3,
      statusCodeFilter: undefined,
      unassignedFilter: filter?.tabTable === 'UNASSIGNED' && filter?.unassignedFilter,
    }),
  })
  const { inquiryCount: installationPersonnelReadinessCount } = useInquiryCount({
    ...updateFilters(filter, {
      activeFilter: filter?.tabTable === 'ACTIVE' && filter?.activeFilter,
      assignedToMe: undefined,
      assignedToOther: undefined,
      customerActionRequiredFilter: undefined,
      elevatedToMPF: null,
      isCPOwnerOrLeadership: null,
      isResponsePending: undefined,
      isResponseRequired: undefined,
      pendingActionOutsideFilter: null,
      returnedFromMPF: null,
      sectionCodeFilter: 4,
      sectionCodeKPIFilter: 4,
      statusCodeFilter: '',
      unassignedFilter: filter?.tabTable === 'UNASSIGNED' && filter?.unassignedFilter,
    }),
  })
  const { inquiryCount: personnelSystemsManagementCount } = useInquiryCount({
    ...updateFilters(filter, {
      activeFilter: filter?.tabTable === 'ACTIVE' && filter?.activeFilter,
      assignedToMe: undefined,
      assignedToOther: undefined,
      customerActionRequiredFilter: undefined,
      elevatedToMPF: null,
      isCPOwnerOrLeadership: null,
      isResponsePending: undefined,
      isResponseRequired: undefined,
      pendingActionOutsideFilter: null,
      returnedFromMPF: null,
      sectionCodeFilter: 5,
      sectionCodeKPIFilter: 5,
      statusCodeFilter: '',
      unassignedFilter: filter?.tabTable === 'UNASSIGNED' && filter?.unassignedFilter,
    }),
  })
  const { inquiryCount: responseRequestCount } = useInquiryCount({
    activeFilter: filter?.tabTable === 'ACTIVE' && filter?.activeFilter,
    assignedToMe: undefined,
    assignedToOther: undefined,
    currentSection: isOwnerOrLeadership ? '' : currentSection,
    customerActionRequiredFilter: undefined,
    isCPOwnerOrLeadership: isOwnerOrLeadership,
    isResponsePending: false,
    isResponseRequired: true,
    notSelfFilter: me.userId,
    pendingActionOutsideFilter: null,
    returnedFromMPF: null,
    sectionCodeKPIFilter: sections?.map((item) => item.SectionCode) || [],
    statusCodeFilter: '',
    unassignedFilter: filter?.tabTable === 'UNASSIGNED' && filter?.unassignedFilter,
  })

  const { inquiryCount: responsePendingCount } = useInquiryCount({
    activeFilter: filter?.tabTable === 'ACTIVE' && filter?.activeFilter,
    assignedToMe: undefined,
    assignedToOther: undefined,
    currentSection: currentSection,
    customerActionRequiredFilter: undefined,
    isCPOwnerOrLeadership: isOwnerOrLeadership,
    isResponsePending: true,
    isResponseRequired: true,
    notSelfFilter: me.userId,
    pendingActionOutsideFilter: null,
    returnedFromMPF: null,
    sectionCodeKPIFilter: sections?.map((item) => item.SectionCode) || [],
    statusCodeFilter: '',
    unassignedFilter: filter?.tabTable === 'UNASSIGNED' && filter?.unassignedFilter,
  })
  const getExtraCount = (section, sectionCode) => {
    const { sectionCodeFilter } = filter
    const isSectionCodeIncluded =
      sectionCodeFilter === -1 ||
      (Array.isArray(sectionCodeFilter) && sectionCodeFilter.includes(sectionCode)) ||
      sectionCodeFilter === sectionCode

    return isSectionCodeIncluded ? twoDigits(section[0]?.InquiryGUID_count || 0) : '00'
  }
  const accordionItems = [
    {
      Id: 0,
      content: (
        <DetailKPIs
          allCount={getExtraCount(careerDevelopmentCount, 1)}
          filter={filter}
          kpiTitle={'subkpis1'}
          sectionCode={1}
          setKpiName={setKpiName}
          updateKpiFilter={updateKpiFilter}
        />
      ),
      extras: defaultToEmptyString(getExtraCount(careerDevelopmentCount, 1)),
      is_active: 'false',
      kpicode: '1',
      title: 'Career Development',
    },
    {
      Id: 2,
      content: (
        <DetailKPIs
          allCount={getExtraCount(customerSupportCount, 2)}
          filter={filter}
          kpiTitle={'subkpis1'}
          sectionCode={2}
          setKpiName={setKpiName}
          updateKpiFilter={updateKpiFilter}
        />
      ),
      extras: defaultToEmptyString(getExtraCount(customerSupportCount, 2)),
      is_active: 'false',
      kpicode: '12',
      title: 'Customer Support',
    },
    {
      Id: 3,
      content: (
        <DetailKPIs
          allCount={getExtraCount(forceManagementCount, 3)}
          filter={filter}
          kpiTitle={'subkpis1'}
          sectionCode={3}
          setKpiName={setKpiName}
          updateKpiFilter={updateKpiFilter}
        />
      ),
      extras: defaultToEmptyString(getExtraCount(forceManagementCount, 3)),
      is_active: 'false',
      kpicode: '13',
      title: 'Force Management',
    },
    {
      Id: 4,
      content: (
        <DetailKPIs
          allCount={getExtraCount(installationPersonnelReadinessCount, 4)}
          filter={filter}
          kpiTitle={'subkpis1'}
          sectionCode={4}
          setKpiName={setKpiName}
          updateKpiFilter={updateKpiFilter}
        />
      ),
      extras: defaultToEmptyString(getExtraCount(installationPersonnelReadinessCount, 4)),
      is_active: 'false',
      kpicode: '14',
      title: 'Installation Personnel Readiness',
    },
    {
      Id: 5,
      content: (
        <DetailKPIs
          allCount={getExtraCount(personnelSystemsManagementCount, 5)}
          filter={filter}
          kpiTitle={'subkpis1'}
          sectionCode={5}
          setKpiName={setKpiName}
          updateKpiFilter={updateKpiFilter}
        />
      ),
      extras: defaultToEmptyString(getExtraCount(personnelSystemsManagementCount, 5)),
      is_active: 'false',
      kpicode: '15',
      title: 'Personnel Systems Management',
    },
    {
      Id: 6,
      content: (
        <ResponseKPIs
          currentSection={currentSection}
          filter={filter}
          kpiTitle={'response requested'}
          setKpiName={setKpiName}
          updateKpiFilter={updateKpiFilter}
        />
      ),
      extras: defaultToEmptyString(twoDigits(responseRequestCount[0]?.InquiryGUID_count)),
      is_active: 'false',
      kpicode: '16',
      title: 'Response Requested',
    },
    {
      Id: 7,
      content: (
        <ResponseKPIs
          currentSection={currentSection}
          filter={filter}
          kpiTitle={'response pending'}
          setKpiName={setKpiName}
          updateKpiFilter={updateKpiFilter}
        />
      ),
      extras: defaultToEmptyString(twoDigits(responsePendingCount[0]?.InquiryGUID_count)),
      is_active: 'false',
      kpicode: '17',
      title: 'Response Pending',
    },
  ]

  useEffect(() => {
    const getSection = async () => {
      const section = await getSectionByCodeOrName({
        isArchivedFilter: null,
        userSections: mpfSection,
      })
      if (typeof section === 'number') {
        setCurrentSection(section)
      }
    }

    if (mpfSection.length > 0) getSection()
  }, [mpfSection])

  return (
    <Accordions
      accordionName='kpis'
      accordionitemclass='border-radius'
      className='accordions accordion-bordered m-2'
      count='border-left1 p-2 ms-auto'
      defaultActivekey='1'
      extras='border-right1 px-3 py-2 poppins-bold font-16'
      icon='icon-arrow-down ms-auto font-15 px-2 bold'
      inputProps={{
        className: 'w-100 p-0 poppins-semibold font-12 border-radius',
        contentclassName: 'border-top2 px-2',
      }}
      isExpandAll={false}
      items={accordionItems}
      responseObj={{
        isPending: responsePendingVisibility(),
        isRequested: responseRequestedVisibility(),
      }}
      titleClass='px-2 text-uppercase'
    />
  )
}
export default AccordionKPIs
